'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjsr_AnonFunction3() {
}
export { $c_sjsr_AnonFunction3 as $c_sjsr_AnonFunction3 };
$p = $c_sjsr_AnonFunction3.prototype = new $j_java$002elang$002e$002dObject.$h_sr_AbstractFunction3();
$p.constructor = $c_sjsr_AnonFunction3;
/** @constructor */
function $h_sjsr_AnonFunction3() {
}
export { $h_sjsr_AnonFunction3 as $h_sjsr_AnonFunction3 };
$h_sjsr_AnonFunction3.prototype = $p;
